import {
  useEffect, useRef, useState
} from "react";

export const AnimatedCounter = ({ end, suffix = "", prefix = "", duration = 2000 }) => {
  const isStatic = typeof end === "string";
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const hasAnimated = useRef(false);

  useEffect(() => {
    if (isStatic) return; // no animation for string values

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true;
          const startTime = Date.now();
          const animate = () => {
            const elapsed = Date.now() - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            setCount(Math.floor(eased * end));
            if (progress < 1) requestAnimationFrame(animate);
          };
          requestAnimationFrame(animate);
        }
      },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [end, duration, isStatic]);

  return (
    <span ref={ref}>
      {prefix}{isStatic ? end : count.toLocaleString()}{suffix}
    </span>
  );
};

